"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.h3(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  font-size: 18px;\n  color: ", ";\n  font-family: ", ";\n"], ["\n  margin: 0;\n  font-size: 18px;\n  color: ", ";\n  font-family: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map